import { stringAvatar } from 'utils';
import { MeInfo } from 'library/types';
import { CollapseMenu } from 'components';
import { useEffect, useState } from 'react';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import HubIcon from '@mui/icons-material/Hub';
import LanIcon from '@mui/icons-material/Lan';
import { styled } from '@mui/material/styles';
import DvrIcon from '@mui/icons-material/Dvr';
import TocIcon from '@mui/icons-material/Toc';
import TuneIcon from '@mui/icons-material/Tune';
import WorkIcon from '@mui/icons-material/Work';
import TaskIcon from '@mui/icons-material/Task';
import PeopleIcon from '@mui/icons-material/People';
import StairsIcon from '@mui/icons-material/Stairs';
// import SourceIcon from '@mui/icons-material/Source';
import StorageIcon from '@mui/icons-material/Storage';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import CategoryIcon from '@mui/icons-material/Category';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
// import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import { Box, List, Toolbar, Avatar, Typography, Stack } from '@mui/material';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export type SideBarItem = {
  name: JSX.Element;
  route: string;
  icon: JSX.Element;
  permissions: string[];
  subMenu?: {
    name: JSX.Element;
    route: string;
    icon: JSX.Element;
    permissions: string[];
  }[];
};

export const sideBarItems: SideBarItem[] = [
  {
    name: <FormattedMessage id="sidebar.dashboard" defaultMessage="Genel Bakış" />,
    route: 'dashboard',
    icon: <DashboardIcon />,
    permissions: [],
  },
  {
    name: <FormattedMessage id="sidebar.freshdeskDashboard" defaultMessage="Freshdesk" />,
    route: 'freshdesk-dashboard',
    icon: <SupportAgentIcon />,
    permissions: ['freshdesk'],
  },
  {
    name: <FormattedMessage id="sidebar.effortTracing" defaultMessage="Efor Takibi" />,
    route: 'effort-tracing',
    icon: <WorkIcon />,
    permissions: ['list-effort'],
  },
  {
    name: <FormattedMessage id="sidebar.projectTracking" defaultMessage="Proje Takibi" />,
    route: '',
    icon: <AccountTreeIcon />,
    permissions: ['create-book', 'add-project-task-list', 'list-project-task', 'list-project-report'],
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.createBook" defaultMessage="Proje Oluştur" />,
        route: 'book',
        icon: <PlaylistAddIcon />,
        permissions: ['create-book'],
      },
      {
        name: <FormattedMessage id="sidebar.projectPlanGenerate" defaultMessage="Proje Planı Oluştur" />,
        route: 'project-plan-generate',
        icon: <TocIcon />,
        permissions: ['add-project-task-list'],
      },
      {
        name: <FormattedMessage id="sidebar.projectStepManaging" defaultMessage="Adım Yönetimi" />,
        route: 'project-step-managing',
        icon: <StairsIcon />,
        permissions: ['list-project-task'],
      },
      {
        name: <FormattedMessage id="sidebar.projectMonitoring" defaultMessage="İzleme / Sunum" />,
        route: 'project-monitoring',
        icon: <DvrIcon />,
        permissions: ['list-project-report'],
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.activityTracking" defaultMessage="Aktivite Takibi" />,
    route: '',
    icon: <TaskIcon />,
    permissions: ['list-activity-board-item', 'list-activity-board-item-admin', 'get-activity-monitoring'],
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.activityManaging" defaultMessage="Aktivite Raporu" />,
        route: 'activity-managing',
        icon: <StairsIcon />,
        permissions: ['list-activity-board-item', 'list-activity-board-item-admin'],
      },
      {
        name: <FormattedMessage id="sidebar.projectMonitoring" defaultMessage="İzleme / Sunum" />,
        route: 'activity-monitoring',
        icon: <DvrIcon />,
        permissions: ['get-activity-monitoring'],
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.personnelHoliday" defaultMessage="İzin Takibi" />,
    route: '',
    icon: <BeachAccessIcon />,
    permissions: ['list-holiday', 'get-activity-board-permissions'],
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.myPersonnelHoliday" defaultMessage="İzin Taleplerim" />,
        route: 'personnel-holiday',
        icon: <BeachAccessIcon />,
        permissions: ['list-holiday'],
      },
      {
        name: <FormattedMessage id="sidebar.holidayMonitoring" defaultMessage="İzleme / Sunum" />,
        route: 'holiday-monitoring',
        icon: <DvrIcon />,
        permissions: ['get-activity-board-permissions'],
      },
      {
        name: <FormattedMessage id="sidebar.yearlyHolidayView" defaultMessage="Yıllık Bakış" />,
        route: 'holiday-yearly-view',
        icon: <CalendarMonthRoundedIcon />,
        permissions: ['get-activity-board-permissions'],
      },
    ],
  },
  // {
  //   name: <FormattedMessage id="sidebar.salesCrm" defaultMessage="Satış CRM" />,
  //   route: '',
  //   icon: <PointOfSaleIcon />,
  //   permissions: ['list-customer-source-type', 'list-sales-stage-type'],
  //   subMenu: [
  //     {
  //       name: <FormattedMessage id="sidebar.customerSourceTypes" defaultMessage="Müşteri Kaynakları" />,
  //       route: 'customer-source-types',
  //       icon: <SourceIcon />,
  //       permissions: ['list-customer-source-type'],
  //     },
  //     {
  //       name: <FormattedMessage id="sidebar.salesStageTypes" defaultMessage="Satış Aşamaları" />,
  //       route: 'sales-stage-types',
  //       icon: <StairsIcon />,
  //       permissions: ['list-sales-stage-type'],
  //     },
  //   ],
  // },
  {
    name: <FormattedMessage id="sidebar.reports" defaultMessage="Raporlar" />,
    route: '',
    icon: <SummarizeIcon />,
    permissions: ['report-page-view'],
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.report" defaultMessage="Proje Raporu" />,
        route: 'report',
        icon: <AssessmentIcon />,
        permissions: [],
      },
      {
        name: <FormattedMessage id="sidebar.productReport" defaultMessage="Ürün Raporu" />,
        route: 'product-report',
        icon: <AccountTreeIcon />,
        permissions: [],
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.adaptations" defaultMessage="Uyarlamalar" />,
    route: '',
    icon: <TuneIcon />,
    permissions: [
      'list-product-group',
      'list-product',
      'list-activity-type',
      'list-connection-type',
      'list-environment-type',
      'list-gib-method',
      'list-bank',
      'list-effort-contact',
      'list-effort-status-contact',
      'list-project-task-base',
    ],
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.projectGroups" defaultMessage="Ürün Grupları" />,
        route: 'project-groups',
        icon: <CategoryIcon />,
        permissions: ['list-product-group'],
      },
      {
        name: <FormattedMessage id="sidebar.projects" defaultMessage="Ürünler" />,
        route: 'projects',
        icon: <AccountTreeIcon />,
        permissions: ['list-product'],
      },
      {
        name: <FormattedMessage id="sidebar.activityTypes" defaultMessage="Aktivite Türleri" />,
        route: 'activity-types',
        icon: <TaskIcon />,
        permissions: ['list-activity-type'],
      },
      {
        name: <FormattedMessage id="sidebar.connectionTypes" defaultMessage="Bağlantı Türleri" />,
        route: 'connection-types',
        icon: <HubIcon />,
        permissions: ['list-connection-type'],
      },
      {
        name: <FormattedMessage id="sidebar.environmentTypes" defaultMessage="Sunucu Tipleri" />,
        route: 'environment-types',
        icon: <StorageIcon />,
        permissions: ['list-environment-type'],
      },
      {
        name: <FormattedMessage id="sidebar.gibTypes" defaultMessage="GİB Yöntemleri" />,
        route: 'gib-types',
        icon: <LanIcon />,
        permissions: ['list-gib-method'],
      },
      {
        name: <FormattedMessage id="sidebar.usedBanks" defaultMessage="Bankalar" />,
        route: 'used-banks',
        icon: <AccountBalanceIcon />,
        permissions: ['list-bank'],
      },
      {
        name: <FormattedMessage id="sidebar.effortContacts" defaultMessage="Efor Muhatapları" />,
        route: 'effort-contacts',
        icon: <AttachEmailIcon />,
        permissions: ['list-effort-contact'],
      },
      {
        name: <FormattedMessage id="sidebar.effortStatusContacts" defaultMessage="Statü <=> Muhatap" />,
        route: 'effort-status-contacts',
        icon: <ForwardToInboxIcon />,
        permissions: ['list-effort-status-contact'],
      },
      {
        name: <FormattedMessage id="sidebar.productProjectPlan" defaultMessage="Ürün - Proje Planı" />,
        route: 'product-project-plan',
        icon: <ListAltIcon />,
        permissions: ['list-project-task-base'],
      },
    ],
  },
  {
    name: <FormattedMessage id="sidebar.tools" defaultMessage="Araçlar" />,
    route: '',
    icon: <SettingsIcon />,
    permissions: ['list-user', 'list-role', 'timeline-page-view', 'list-effort-timeline'],
    subMenu: [
      {
        name: <FormattedMessage id="sidebar.users" defaultMessage="Kullanıcılar" />,
        route: 'users',
        icon: <PeopleIcon />,
        permissions: ['list-user'],
      },
      {
        name: <FormattedMessage id="sidebar.roles" defaultMessage="Roller" />,
        route: 'roles',
        icon: <RoomPreferencesIcon />,
        permissions: ['list-role'],
      },
      {
        name: <FormattedMessage id="sidebar.timeline" defaultMessage="Tarihçe" />,
        route: 'timeline',
        icon: <TimelineOutlinedIcon />,
        permissions: ['timeline-page-view'],
      },
      {
        name: <FormattedMessage id="sidebar.effortTimeline" defaultMessage="Efor Tarihçe" />,
        route: 'effort-timeline',
        icon: <TimelineOutlinedIcon />,
        permissions: ['list-effort-timeline'],
      },
    ],
  },
];

type SideBarProps = {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
};

const SideBar = ({ mobileOpen = false, onMobileClose }: SideBarProps) => {
  const [profileInfo, setProfileInfo] = useState<MeInfo | null>(null);

  useEffect(() => {
    let active = true;

    const getValues = async () => {
      try {
        const response = await apiService.me();

        if (active && response.isSuccess) {
          setProfileInfo(response.data);
        }
      } catch {}
    };

    getValues();

    return () => {
      active = false;
    };
  }, []);

  const drawerContent = (
    <>
      <Toolbar />

      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
          <List dense>
            {sideBarItems.map((item, index) => (
              <CollapseMenu sideBarItem={item} key={item.route || `sidebar-group-${index}`} />
            ))}
          </List>
        </Stack>
      </Box>

      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}>
        <Avatar
          sizes="small"
          alt={profileInfo?.nameSurname}
          {...stringAvatar(profileInfo?.nameSurname || '- -')}
          sx={{ width: 36, height: 36 }}
        />

        <Box sx={{ mr: 'auto', minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }} noWrap>
            {profileInfo?.nameSurname || '- -'}
          </Typography>

          <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
            {profileInfo?.email || '-'}
          </Typography>
        </Box>
      </Stack>
    </>
  );

  return (
    <>
      {/* Mobile temporary drawer */}
      <MuiDrawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          [`& .${drawerClasses.paper}`]: {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: 'background.paper',
          },
        }}>
        {drawerContent}
      </MuiDrawer>

      {/* Desktop permanent drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          [`& .${drawerClasses.paper}`]: {
            backgroundColor: 'background.paper',
          },
        }}>
        {drawerContent}
      </Drawer>
    </>
  );
};

export default SideBar;
